module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isLoaded) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Dados do Proprietário ou Representante Legal")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.cadastroError !== null) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-danger",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "m-b-sm font-bold"
  }, [_vm._v("Erro ao registrar, corrija e tente novamente")]), _vm._v(" "), _vm._l((_vm.cadastroError), function(erro, key) {
    return _c('p', [_vm._v(_vm._s(_vm.printError(erro)))])
  })], 2) : _vm._e(), _vm._v(" "), _c('a', {
    ref: "sucessMsg",
    attrs: {
      "name": "sucessMsg",
      "id": "sucessMsg",
      "href": "javascript:void(0)"
    }
  }), _vm._v(" "), (_vm.atualizadoSucesso !== null && _vm.atualizadoSucesso) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-success",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "font-bold"
  }, [_vm._v(_vm._s(_vm.$route.params.id && 'Atualizado' || 'Cadastrado') + " com sucesso!")])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "bs-example form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.nome),
      expression: "data.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "nome", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("RG")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.rg),
      expression: "data.rg"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.rg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "rg", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("CPF")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.cpf),
      expression: "data.cpf"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('###.###.###-##'),
      expression: "'###.###.###-##'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.cpf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "cpf", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Número de acesso")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.numeroAcesso),
      expression: "data.numeroAcesso"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "required": "",
      "disabled": !_vm.editNumeroAcesso
    },
    domProps: {
      "value": (_vm.data.numeroAcesso)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "numeroAcesso", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5",
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editNumeroAcesso),
      expression: "editNumeroAcesso"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.editNumeroAcesso) ? _vm._i(_vm.editNumeroAcesso, null) > -1 : (_vm.editNumeroAcesso)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.editNumeroAcesso,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.editNumeroAcesso = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.editNumeroAcesso = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.editNumeroAcesso = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "control-label m-l-sm"
  }, [_vm._v("Editar número de acesso")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Lista de Itens")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._l((_vm.data.listaItens), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "row m-b-sm",
      staticStyle: {
        "display": "flex",
        "align-items": "center"
      }
    }, [_c('div', {
      staticClass: "col-sm-10"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (_vm.data.listaItens[key]),
        expression: "data.listaItens[key]",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "required": ""
      },
      domProps: {
        "value": (_vm.data.listaItens[key])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.data.listaItens, key, $event.target.value.trim())
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('u-button', {
      staticClass: "btn-link btn-xs",
      on: {
        "click": function($event) {
          return _vm.data.listaItens.splice(key, 1)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times text-danger"
    })])], 1)])
  }), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-info btn-xs",
    on: {
      "click": function($event) {
        return _vm.data.listaItens.push('')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Adicionar Item")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row wrapper"
  }, [_c('u-button', {
    staticClass: "btn m-b-xs w-xs btn-info m-r-xs",
    on: {
      "click": _vm.submit
    }
  }, [(!_vm.data.id) ? _c('span', [_vm._v("Cadastrar")]) : _vm._e(), _vm._v(" "), (_vm.data.id) ? _c('span', [_vm._v("Atualizar")]) : _vm._e()]), _vm._v(" "), _c('u-button', {
    staticClass: "btn m-b-xs w-xs m-r-xs btn-default",
    on: {
      "click": function($event) {
        return _vm.$emit('finishSubmit')
      }
    }
  }, [_vm._v("Cancelar")])], 1)])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ad4a4fe4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/grvs/components/DeclaracaoAcessoVeiculoForm.vue
// module id = 2029
// module chunks = 18